import type { ButtonProps } from "@p0security/ui";
import { Button } from "@p0security/ui";
import { useCallback, useState } from "react";

import { RequestAccessModal } from "./RequestAccessModal";

export const RequestAccessModalButton: React.FC<
  Pick<ButtonProps, "children" | "icon" | "type" | "variant"> & {
    /** If present, the modal is prefilled from this previously created request */
    requestId?: string;
  }
> = ({
  children = "Request Access",
  icon,
  requestId,
  type = "primary",
  variant = "filled",
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleShowCreateRequestModal = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const handleRequestAccessModalCancel = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  return (
    <>
      <Button
        type={type}
        variant={variant}
        icon={icon}
        onClick={handleShowCreateRequestModal}
      >
        {children}
      </Button>
      {isModalOpen && (
        <RequestAccessModal
          open={isModalOpen}
          onCancel={handleRequestAccessModalCancel}
          requestId={requestId}
        />
      )}
    </>
  );
};
